import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_PASSPORT_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'passport',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.INDEX },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "lk-passport.store" */
        './store'
      )
      const { registerModule: handbookRegisterModule } = await import(
        /* webpackChunkName: "form-handbook.store" */
        '@/views/FormsHandbook/store/cache'
      )
      registerModule(options)
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'ViewLKPassportLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.INDEX,
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-passport.index" */
          './LKPassportIndex.vue'
        ),
      },
      {
        path: 'stats/',
        name: ROUTES.STATISTICS,
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-passport.stats" */
          './LKPassportStats.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
